import React from "react";
import { useContacts } from "../hooks";

interface IProps {
  customerId: number;
}

export const PrimaryContactCell: React.FC<IProps> = ({ customerId }) => {
  const { data, loading } = useContacts({ where: { customerId } });

  if (loading) return <span className="text-gray-400">…</span>;

  const primaryContact =
    data?.contacts?.results?.find((contact) => contact.isPrimary) ??
    data?.contacts?.results?.[0];

  if (!primaryContact) return <span className="text-gray-400">-</span>;

  return (
    <span>
      {primaryContact.firstname} {primaryContact.lastname}
    </span>
  );
};
